module.exports = __webpack_public_path__ + "img/total-collected.698853a7.svg";